import React, { useEffect, useState } from "react";
import DashboardMetrics from "../components/DashboardMetrics";
import BusinessCategoryTable from "../components/BusinessCategoryTable";
import TotalSubscribers from "../components/TotalSubscribers";
// import DownloadReports from "../components/DownloadReports";
import { dashboarddata } from "../services/api"; // Import your API function
import { ShimmerDiv } from "shimmer-effects-react"; // Correct shimmer component
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";



const Dashboard = () => {
  // State to hold API data
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();


  // Fetch data from the API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await dashboarddata();
        setData(result); // Set the result to state
      } catch (error) {
        setError("Failed to fetch dashboard data.");
      } finally {
        setLoading(false); // Stop loading once the request is done
      }
    };
    fetchData();
  }, []);

  // Show loading animation or error message if needed
  if (loading) {
    return (
      <div className="p-5 grid gap-8  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center justify-between">
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
        <ShimmerDiv mode="dark" height={150} width={300} border={0} rounded={1} />
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  const {
    totalOrders,
    totalProducts,
    totalCategories,
    totalSubcategories,
    totalEarnings,
    totalSubscribers,
    totalUsers,
    totalVendors,
  } = data;

  
  return (
    <>
    <TopBar hideSearch />

    <div className="ml-0 mt-5">
      <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 px-5 pt-1">
        <DashboardMetrics title="Total Orders" count={totalOrders} onClick={() => navigate("/orders")}/>
        <DashboardMetrics title="Total Products" count={totalProducts} />
        <DashboardMetrics title="Total Categories" count={totalCategories} onClick={() => navigate("/category")} />
        <DashboardMetrics
          title="Total Subcategories"
          count={totalSubcategories}
        />
        <DashboardMetrics title="Total Earnings" count={`€ ${totalEarnings}`} />
        <DashboardMetrics title="Total Subscribers" count={totalSubscribers} />
        <DashboardMetrics title="Total Users" count={totalUsers} onClick={() => navigate("/users")} />
        <DashboardMetrics title="Total Vendors" count={totalVendors} onClick={() => navigate("/vendors")}/>
      </div>
      <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 p-5">
        <div className="lg:col-span-3 md:col-span-2 col-span-1">
          <BusinessCategoryTable />
        </div>
        <div className="lg:col-span-1 md:col-span-1 col-span-1 space-y-6">
          <TotalSubscribers />
          {/* <DownloadReports /> */}
        </div>
      </div>
    </div>
    </>
  );
};

export default Dashboard;
